import { NoteBlank } from '@phosphor-icons/react';

export default NoteBlank;
